
import { AsyncPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, OnDestroy, OnInit, viewChild } from '@angular/core';
import { AppStorage } from '@app/common/services/data-api/app-storage.service';
import { kendoIcons } from '@app/shared/library/kendo-icons';
import { SVGIconComponent } from '@progress/kendo-angular-icons';
import { LoaderComponent } from '@progress/kendo-angular-indicators';
import { PopupComponent } from '@progress/kendo-angular-popup';
import { IAssetTeam } from 'app/shared/interfaces';
import { AssetTeam } from 'app/shared/models';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-assetteam-selection',
  templateUrl: './assetteam-selection.component.html',
  styleUrls: ['./assetteam-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '(document:click)': 'documentClick($event)',
  },
  imports: [
    AsyncPipe,
    LoaderComponent,
    NgClass,
    PopupComponent,
    SVGIconComponent,
  ],
})
export class AssetTeamSelectionComponent implements OnInit, OnDestroy {
  appStore = inject(AppStorage);

  private subscription: Subscription;
  public icons = kendoIcons;

  public readonly popup = viewChild('popup', { read: ElementRef });
  public readonly assetteam_selector_anchor = viewChild<ElementRef>('assetteam_selector_anchor');
  
  public selectedTeam: AssetTeam = null;
  public teams: AssetTeam[] = [];
  public assetTeamList: AssetTeam[] = [];

  public loaded: boolean = false;
  public show = false;
  public loading = true;

  constructor() {

    let iTeam: IAssetTeam = {
      AssetTeamId: 1,
      NonStandardAssetTeamCode: 'CORP',
      AssetTeamCode: 'CORP',
      Name: 'Corporate',
      Shape: null,
      Description: '',
      SortOrder: 0,
      Assets_AssetTeam: null,
      Legacy: false,
      RigDepotLocation: null,
      Areas_AssetTeam: null,
      DefaultProjectTeams_AssetTeam: null,
      Divisions_AssetTeam: null,
      DrillDesigns_AssetTeam: null,
      EffectivePercentAttainments_AssetTeam: null,
      Pads_AssetTeam: null,
      Ponds_AssetTeam: null,
      Projects_AssetTeam: null,
      ProjectTemplates_AssetTeam: null,
      Rigs_AssetTeam: null,
      SaltWaterDisposalFacilities_AssetTeam: null,
      ScenarioDetails_AssetTeam: null,
      Scenarios_AssetTeam: null,
      Settings_AssetTeam: null,
      TankBatteries_AssetTeam: null,
      TargetFormations_AssetTeam: null,
      TeamDevelopmentAreas_AssetTeam: null,
      TypeCurves_AssetTeam: null,
      WaterDisposalSystems_AssetTeam: null,
      WaterWells_AssetTeam: null,
      Pads_LegacyAssetTeam: null,
      SaltWaterDisposalFacilities_LegacyAssetTeam: null,
      TankBatteries_LegacyAssetTeam: null,
      CompletionDesigns_AssetTeam: null,
      StandardConfigurationAssetTeams_AssetTeam: null,
      Created: new Date(),
      CreatedBy: '',
      Updated: new Date(),
      UpdatedBy: '',
      SsnPrefix: ''
    };
    this.selectedTeam = new AssetTeam(iTeam);
  }

  public documentClick(event: any): void {
    this.closePopup(event.target);
  }

  private closePopup(target: any): void {
    const popup = this.popup();
    if (
      !this.assetteam_selector_anchor().nativeElement.contains(target) &&
      !(popup ? popup.nativeElement.contains(target) : false)
    ) {
      this.show = false;
    }
  }

  public onToggle(): void {
    this.show = !this.show;
  }

  public selectTeam(a: AssetTeam) {
    setTimeout(() => {
      this.appStore.knownStore.trySetAssetTeam(a).subscribe(ok => {
        if (ok) {
          this.selectedTeam = a;
          this.show = false;
        }
      });
    }, 10);
  }

  getAssetTeamName(code: string): string {
    const teamName = this.assetTeamList.find(t => t.AssetTeamCode === code);
    return teamName ? `${teamName.AssetTeamCode} - ${teamName.Name}` : code;
  }

  ngOnInit() {
    this.subscription = this.appStore.knownEvents.assetTeamSelected.subscribe(assetTeam => {
      this.selectedTeam = this.appStore.knownStore.assetTeam;
    });
    this.appStore.knownTables.assetTeams.pipe(map(s => {
      return s;
    })).subscribe((r) => {
      if (r && r.length) {
        this.assetTeamList = r; //need full list
        if (!this.loaded) {
          //TODO: select the asset team based on the current logged in user          
          let lastAssetTeamId = this.appStore.knownStore.lastAssetTeamId();
          if (lastAssetTeamId) {
            this.selectedTeam = r.find(at => at.AssetTeamId === +lastAssetTeamId);
          }
          else {
            this.selectedTeam = r.find(at => at.AssetTeamCode === 'PAT');
          }

          this.loaded = true;
          this.appStore.knownStore.assetTeam = this.selectedTeam;
          this.loading = false;
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  public tracksFn(index, item: AssetTeam) {
    return item.AssetTeamId;
  }
}